// BTP-Suivi · Helpers API pour l'Espace Sous-traitant.
// Wrapper léger autour de `api` pour les 14 endpoints /api/soustraitant/*
// (cf. backend/routers/soustraitant.py) + endpoints admin owner.
//
// Convention : les fonctions renvoient directement `data` (pas la réponse axios).
// La gestion des erreurs (toast) reste à la charge du caller via try/catch.
import { api } from "./api";

// ─── Côté sous-traitant authentifié ─────────────────────────────────────

export const soustraitantApi = {
  // Profil
  async getMe() {
    const { data } = await api.get("/soustraitant/me");
    return data;
  },
  async updateMe(patch) {
    const { data } = await api.patch("/soustraitant/me", patch);
    return data;
  },
  async updateTaux(taux_horaire_ht) {
    const { data } = await api.patch("/soustraitant/me/taux-horaire", { taux_horaire_ht });
    return data;
  },

  // Chantiers affectés
  async listChantiers() {
    const { data } = await api.get("/soustraitant/chantiers");
    return data.items || [];
  },
  async getChantier(id) {
    const { data } = await api.get(`/soustraitant/chantiers/${id}`);
    return data;
  },

  // Tâches assignées
  async listTaches({ statut, chantier_id } = {}) {
    const { data } = await api.get("/soustraitant/taches", {
      params: { statut, chantier_id },
    });
    return data.items || [];
  },

  // Factures
  async listFactures({ statut, chantier_id } = {}) {
    const { data } = await api.get("/soustraitant/factures", {
      params: { statut, chantier_id },
    });
    return data.items || [];
  },
  async getFacture(id) {
    const { data } = await api.get(`/soustraitant/factures/${id}`);
    return data;
  },
  async createFacture(payload) {
    const { data } = await api.post("/soustraitant/factures", payload);
    return data;
  },
  async updateFacture(id, patch) {
    const { data } = await api.patch(`/soustraitant/factures/${id}`, patch);
    return data;
  },
  async deleteFacture(id) {
    await api.delete(`/soustraitant/factures/${id}`);
  },
  async uploadFacturePdf(id, payload) {
    const { data } = await api.post(`/soustraitant/factures/${id}/upload-pdf`, payload);
    return data;
  },
  async sendFacture(id) {
    const { data } = await api.post(`/soustraitant/factures/${id}/send`);
    return data;
  },
  async cancelFacture(id) {
    const { data } = await api.post(`/soustraitant/factures/${id}/cancel`);
    return data;
  },
};

// ─── Côté admin owner ────────────────────────────────────────────────────

export const soustraitantAdminApi = {
  // Sous-traitants
  async list(params = {}) {
    const { data } = await api.get("/admin/soustraitants", { params });
    return data.items || [];
  },
  async get(id) {
    const { data } = await api.get(`/admin/soustraitants/${id}`);
    return data;
  },
  async create(payload) {
    const { data } = await api.post("/admin/soustraitants", payload);
    return data;
  },
  async update(id, patch) {
    const { data } = await api.patch(`/admin/soustraitants/${id}`, patch);
    return data;
  },
  async suspend(id) {
    const { data } = await api.post(`/admin/soustraitants/${id}/suspend`);
    return data;
  },
  async archive(id) {
    const { data } = await api.post(`/admin/soustraitants/${id}/archive`);
    return data;
  },
  async reactivate(id) {
    const { data } = await api.post(`/admin/soustraitants/${id}/reactivate`);
    return data;
  },

  // Affectation chantier
  async listChantierST(chantier_id) {
    const { data } = await api.get(`/admin/chantiers/${chantier_id}/soustraitants`);
    return data.items || [];
  },
  async affectST(chantier_id, payload) {
    const { data } = await api.post(`/admin/chantiers/${chantier_id}/affecter-soustraitant`, payload);
    return data;
  },
  async removeST(chantier_id, st_id) {
    await api.delete(`/admin/chantiers/${chantier_id}/soustraitants/${st_id}`);
  },

  // Factures (vue admin)
  async listFactures(params = {}) {
    const { data } = await api.get("/admin/factures", { params });
    return data.items || [];
  },
  async validateFacture(id, payload = {}) {
    const { data } = await api.post(`/admin/factures/${id}/validate`, payload);
    return data;
  },
  async refuseFacture(id, motif_refus) {
    const { data } = await api.post(`/admin/factures/${id}/refuse`, { motif_refus });
    return data;
  },
  async markFacturePaid(id, payload) {
    const { data } = await api.post(`/admin/factures/${id}/mark-paid`, payload);
    return data;
  },
};
